import magnifiAPIInstance from "./apiInstance";

export const srtSecretAPIs = {
  getSrtSecrets: ({ payload }) =>
    magnifiAPIInstance.get(`/get_all_srt_encryption?page_no=${payload.page_no || 1}&limit=${payload.limit || 20}`),
  processSrtSecretKey: (payload) => magnifiAPIInstance.post(`/process_srt_encryption`, payload),
};
